
























































































import {Mall} from '@/views/claim/dataType/OrderProductOption';
import {Component, Vue} from 'vue-property-decorator';
import ComponentItemsClaim from '@/views/claim/components/ComponentItemsClaim.vue';
import ComponentDiscountShippingFee from '@/views/claim/components/ComponentDiscountShippingFee.vue';
import ComponentProductDetails from '@/views/claim/components/ComponentProductDetails.vue';
import ComponentRefundExchangeAmount from '@/views/claim/components/ComponentRefundExchangeAmount.vue';
import ComponentBenefitsPaid from '@/views/claim/components/ComponentBenefitsPaid.vue';
import {
  GetOrderProductsRequest,
  GetOrderProductsOrderOption,
  PostOrderCancelsPredictRequest,
  PostOrderCancelsRequest,
  GetClaimsOrderOptionsOrderOptionNoApplyRequest,
  ProductsDetailUrl
} from 'supporter';
import {ComponentItemsClaimDataType, ClaimableOption} from '@/views/claim/components/dataType/ComponentDataType';
import {addClass} from '@/utils/classUtils';
import { addProductDetailUrlPreview } from '@/utils/formatUtils';
import { convertProductUri } from '@/utils/commonUtils';

@Component({
  components: {ComponentItemsClaim, ComponentDiscountShippingFee, ComponentProductDetails, ComponentRefundExchangeAmount, ComponentBenefitsPaid}
})
export default class CancelAllPopup extends Vue {
  private displayedDeliveryAmtDiscountMessage: boolean = false;
  private objJson = '';
  private postOptionCancelsPredict!: any;
  // private productUrl!: string | undefined;
  private pageName = 'CancelAllPopup';
  private type: string = '';
  private title: string = '';
  private showA: boolean = false;
  private mall: Mall = {
    countryCd: 'KR'
  };
  private orderOptionsApply: ComponentItemsClaimDataType = {
    orderNo: '',
    claimableOptions: [],
    refundTypes: [],
    payType: ''
  };

  private productsDetailUrls: ProductsDetailUrl[] = [];
  private refundTypeDivShow: boolean = true;
  private zeroRefundShow: boolean = false;
  private refundBankInfoTrShow: boolean = true;
  private refundTypeValue: string;
  private async getProductsDetailUrls() {
    await this.$api.getProductsDetailUrls().then((ret: any) => {
      this.productsDetailUrls = ret.data.map(d => {
        d.url = addProductDetailUrlPreview(d.url);
        return d
      });
    });
  }
  private holdByReservation: boolean = false;
  private holdProcess: boolean = false;
  private isShow: boolean = false;

  private created() {
    this.initPostOptionCanclesPredict();
    this.getProductsDetailUrls();
    this.getClaimOrderPredict();
    this.type = String(this.$route.query.type);
    if ('before' === this.type) {
      this.title = this.$t('CLAIM_CANCELPOPUP_CANCELLBEFOREDEPOS').toString();
    } else if ('normal' === this.type) {
      this.title = this.$t('CLAIM_CANCELPOPUP_CANCELLATIONAFTERPAYMENT').toString();
    }
  }

  private getClaimOrderPredict() {
    let request: GetOrderProductsRequest = {
      params: {
        orderNo: String(this.$route.query.orderNo)
      }
    };
    let partnernoMap: Map<number, ClaimableOption[]> = new Map();
    this.$api.getOrderProducts(request).then((ret: any) => {
      this.holdByReservation = false;
      ret.data.forEach((item: any) => {
        item.orderOptions.forEach((element: GetOrderProductsOrderOption) => {
          let productsDetailUrls: ProductsDetailUrl[] = this.productsDetailUrls.filter((item: ProductsDetailUrl): any => {
            return item.mallNo === element.mallNo;
          });
          let claimableOption: ClaimableOption = {
            ...element,
            checkboxValue: false,
            mallOptionNo: element.mallOptionNo,
            userInputText: [],
            orderNo: element.orderNo,
            immediateDiscountAmt: element.immediateDiscountAmt,
            salePrice: element.salePrice,
            orderStatusType: element.orderStatusType,
            optionValue: element.optionValue,
            orderCnt: element.orderCnt,
            addPrice: element.addPrice,
            mallProductNo: element.mallProductNo,
            claimedCnt: element.orderCnt,
            productName: element.productName,
            claimStatusType: element.claimStatusType,
            additionalDiscountAmt: element.additionalDiscountAmt,
            freeGiftDiscountAmt: element.freeGiftDiscountAmt,
            optionName: element.optionName,
            orderOptionNo: element.orderOptionNo,
            partnerNo: element.partnerNo,
            partnerName: element.partnerName,
            payType: element.payType,
            productUrl: productsDetailUrls && productsDetailUrls.length > 0 ? convertProductUri(productsDetailUrls[0].url, element.mallProductNo.toString()) : '',
            holdProcess: false,
            holdByReservation: element.reservation.holdByReservation || this.holdByReservation,
            optionManagementCd: element.optionManagementCd,
            usesOption: element.usesOption,
            hasSetOption: element.setOptionJson != '' && element.setOptionJson != null,
            setOptions: JSON.parse(element.setOptionJson)
          };
          this.holdByReservation = element.reservation.holdByReservation || this.holdByReservation;
          let temp: ClaimableOption[] | undefined = partnernoMap.get(element.partnerNo);
          if (temp && temp !== undefined) {
            temp.push(claimableOption);
            partnernoMap.set(element.partnerNo, temp);
          } else {
            let temp: ClaimableOption[] = [];
            temp.push(claimableOption);
            partnernoMap.set(element.partnerNo, temp);
          }
        });
      });
      partnernoMap.forEach((value: ClaimableOption[], key: number) => {
        value.forEach((mapvalue: ClaimableOption) => {
          this.orderOptionsApply.claimableOptions.push(mapvalue);
        });
      });

      let request: GetClaimsOrderOptionsOrderOptionNoApplyRequest = {
        pathParams: {
          orderOptionNo: this.orderOptionsApply.claimableOptions[0].orderOptionNo.toString()
        },
        params: {
          claimType: 'CANCEL'
        }
      };

      this.orderOptionsApply.orderNo = String(this.$route.query.orderNo);
      if (this.type === 'normal') {
        this.$api.getClaimsOrderOptionsOrderOptionNoApply(request).then((ret: any) => {
          this.isShow = true;
          this.orderOptionsApply.refundTypes = ret.data.refundTypes;
          this.orderOptionsApply.payType = ret.data.payType;
          this.refundTypeValue = this.getPayType(ret.data.payType);
          this.showA = true;

          let postOrderCanclesPredictRequeset: PostOrderCancelsPredictRequest = {
            data: {
              refundType: this.getPayType(this.orderOptionsApply.payType),
              orderNo: String(this.$route.query.orderNo),
            }
          };
          this.$api.postOrderCancelsPredict(postOrderCanclesPredictRequeset).then((ret: any) => {
            
            this.postOptionCancelsPredict = ret.data;
            this.postOptionCancelsPredict.amounts.beforeAccumulationAmt = this.postOptionCancelsPredict.amounts.before.accumulation.accumulationAmt
            this.postOptionCancelsPredict.amounts.afterAccumulationAmt = this.postOptionCancelsPredict.amounts.after.accumulation.accumulationAmt
            this.postOptionCancelsPredict.amounts.totalAccumulationAmt = this.postOptionCancelsPredict.amounts.afterAccumulationAmt - this.postOptionCancelsPredict.amounts.beforeAccumulationAmt
            this.objJson = JSON.stringify(ret.data);
            this.postOptionCancelsPredict.amounts.refund.order.totalDeliveryAmt = this.postOptionCancelsPredict.amounts.refund.coupon.cartCouponDiscountAmt - this.postOptionCancelsPredict.amounts.refund.delivery.totalDeliveryAmt;
            if(this.postOptionCancelsPredict.amounts.adjustedAmounts.payAmt === 0) {
              this.refundTypeDivShow = false; // 환불방법
              this.zeroRefundShow = true; // 환불금액 없음
              this.refundBankInfoTrShow = false; // 환불계좌번호
              this.refundTypeValue = 'ZERO_REFUND';
            }
          });
        })
        .catch((error: any) => {
          // alert(error.data.message);
          window.opener.location.reload();
          window.close();
        });
      } else {
        let postOrderCanclesPredictRequeset: PostOrderCancelsPredictRequest = {
          data: {
            refundType: 'ACCOUNT',
            orderNo: String(this.$route.query.orderNo),
          }
        };
        this.$api.postOrderCancelsPredict(postOrderCanclesPredictRequeset).then((ret: any) => {
          this.postOptionCancelsPredict = ret.data;
          this.postOptionCancelsPredict.amounts.beforeAccumulationAmt = this.postOptionCancelsPredict.amounts.before.accumulation.accumulationAmt
          this.postOptionCancelsPredict.amounts.afterAccumulationAmt = this.postOptionCancelsPredict.amounts.after.accumulation.accumulationAmt
          this.postOptionCancelsPredict.amounts.totalAccumulationAmt = this.postOptionCancelsPredict.amounts.afterAccumulationAmt - this.postOptionCancelsPredict.amounts.beforeAccumulationAmt
          this.objJson = JSON.stringify(ret.data);
          this.refundTypeValue = 'ZERO_REFUND';
          this.refundBankInfoTrShow = false; // 환불계좌번호
          this.refundTypeDivShow = false;
        });
        this.showA = true;
        this.isShow = true;
      }
    })
  }

  public getPayType(payType: string) {
    switch (payType) {
      case 'ACCOUNT':
        return 'ACCOUNT'

      case 'ACCUMULATION':
        return 'ACCUMULATION'

      case 'ZERO_PAY':
        return 'ZERO_REFUND'

      case 'VIRTUAL_ACCOUNT':
      case 'ESCROW_VIRTUAL_ACCOUNT':
        return 'PG';

      default:
        return 'PG';
    }
  }

  public close(): void {
    window.close();
  }

  private onClickApplyCancel() {
    let orderOptionParams: {
      claimCnt: number;
      orderOptionNo: number;
    }[] = [];
    for (var i = 0; i < (this.$refs.componentItemsClaim as any).optionno.length; i++) {
      let claimCnt = (this.$refs.componentItemsClaim as any).orderCntMap.get((this.$refs.componentItemsClaim as any).optionno[i]) || 0;

      orderOptionParams.push({
        claimCnt: claimCnt,
        orderOptionNo: (this.$refs.componentItemsClaim as any).optionno[i]
      });
    }

    let bank = '';
    let bankNm = '';
    if((this.$refs.componentRefundExchangeAmount as any).refundBankEditShow === false) {
      bank = null
      bankNm = null
    } else {
      bank = (this.$refs.componentRefundExchangeAmount as any).refundBankValue;
      (this.$refs.componentRefundExchangeAmount as any).refundBankList.forEach((element: {value: string; name: string}) => {
        if (element.value == (this.$refs.componentRefundExchangeAmount as any).refundBankValue) {
          bankNm = element.name;
        }
      });
    }
    let request: PostOrderCancelsRequest = {
      data: {
        responsibleObjectType: (this.$refs.componentItemsClaim as any).responsibleObjectTypeValue,
        refundType: (this.$refs.componentRefundExchangeAmount as any).refundTypeValue,
        reasonDetail: (this.$refs.componentItemsClaim as any).claimReasonDetail,
        orderNo: this.orderOptionsApply.orderNo,
        reasonType: (this.$refs.componentItemsClaim as any).claimReasonType,
        refundBankAccount: {
          depositorName: (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName,
          bank: bank,
          bankName: bankNm,
          account: (this.$refs.componentRefundExchangeAmount as any).refundBankAccount
        }
      }
    };
    if (!this.validation()) {
      return;
    }

    this.$api.postOrderCancels(request).then((): any => {
      alert(this.$t('CLAIM_CANCELPOPUP_PROCESS_SUCCESS_MESSAGE'));
      window.opener.location.reload();
      this.close();
    });
  }

  private validation(): boolean {
    if (this.checkHoldDelivery()) {
      return false;
    }
    if (this.checkHoldByReservation()) {
      return false;
    }

    let needBankAccount = false
    switch ((this.$refs.componentRefundExchangeAmount as any).refundTypeValue) {
      case 'CASH':
      case 'ACCOUNT':
        needBankAccount = true;
        break;
      case 'PG':
        if(this.orderOptionsApply.payType === 'VIRTUAL_ACCOUNT' || this.orderOptionsApply.payType === 'ESCROW_VIRTUAL_ACCOUNT') {
          needBankAccount = true;
        }
        break;
    }

    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankValue == '') {
      alert(this.$t('CLAIM_CANCELPOPUP_ALTER1'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBank.focus();
      return false;
    }

    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankAccount == '') {
      alert(this.$t('CLAIM_CANCELPOPUP_ALTER2'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankAccountRef.focus();
      return false;
    }

    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName == '') {
      alert(this.$t('CLAIM_CANCELPOPUP_ALTER3'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankDepositorNameRef.focus();
      return false;
    }

    return true;
  }

  private checkHoldByReservation(): boolean {
    return this.holdByReservation == true && !confirm(this.$t('CLAIM_CANCELPOPUP_RESERVATION_CONFIRM').toString());
  }
  private checkHoldDelivery(): boolean {
    return this.holdProcess == true && !confirm(this.$t('CLAIM_CANCELPOPUP_CONFIRM').toString());
  }

  private initPostOptionCanclesPredict() {
    let postOptionCanclesPredictTemp: any = {
      shipping: {
        requiresShipping: true,
        address: {
          address: '',
          name: '',
          jibunAddress: '',
          detailAddress: '',
          zipCd: '',
          contact1: '',
          contact2: ''
        },
        shippingNo: 0,
        hasAdjustedExchangeDeliveryAmt: false,
        divided: true,
        deliveryGroupNo: 0,
        deliveryType: '',
        prepaid: true,
        deliveryTemplateNo: 0,
        combined: true,
        originalShippingNo: 0
      },
      coupon: {
        productCoupons: [
          {
            couponName: '',
            couponIssueNo: 0,
            orderProductNo: 0,
            restores: true,
            couponNo: 0
          }
        ],
        cartCoupon: {
          couponName: '',
          couponIssueNo: 0,
          orderProductNo: 0,
          restores: true,
          couponNo: 0
        }
      },
      amounts: {
        deliveryAdjustAmt: 0,
        additionalDeliveryAmt: 0,
        adjustedAmounts: {
          mainPayAmt: 0,
          accumulationPayAmt: 0,
          claimAmt: 0,
          additionalPayAmt: 0,
          payAmt: 0
        },
        before: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0
          },
          accumulation: {
            accumulationAmt: 0
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0
          }
        },
        after: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0
          },
          accumulation: {
            accumulationAmt: 0
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0
          }
        },
        additionalPayAmt: 0,
        refund: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0
          },
          accumulation: {
            accumulationAmt: 0
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0
          }
        }
      },
      overflowsPgAmt: false
    };
    this.postOptionCancelsPredict = postOptionCanclesPredictTemp;
    this.objJson = JSON.stringify(postOptionCanclesPredictTemp);
  }

  public popupResize(): void {
    let contentWidth = $('#container').width() + 30;
    let contentHeight = $('#container').height() + 76;
    window.resizeTo(contentWidth, contentHeight);
  }

  public mounted() {
    addClass(document.body, 'popup popup_large');
    setTimeout(() => {this.popupResize()},1000)
  }

  private get isNaverPay(){
    return this.orderOptionsApply.payType === 'NAVER_PAY'
  }
}
